import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SignalEntityQuery} from 'src/app/modules/shared/state/signal-entity.store';
import {ClaimsQuestionsState, ClaimsQuestionStore} from './claims-questions.store';
import {FlowQuestion} from 'src/app/modules/shared/models/claim.model';

@Injectable({
    providedIn: 'root'
})
export class ClaimsFlowQuestionsDataQuery extends SignalEntityQuery<FlowQuestion, ClaimsQuestionsState> {
    constructor(protected store: ClaimsQuestionStore) {
        super(store);
    }

    getClaimFlowQuestions(): Observable<any>{
        return this.selectAll();
    }

    getByParentControl(parent_id: any): Observable<any>{
        console.log("PArentID:: " + parent_id);
        return this.selectAll({
            filterBy: [
                entity => entity.parent_control !== null && entity.parent_control === parent_id
            ]
        });
    }

    getByComponent(component: any){
        return this.selectAll({
            filterBy: [
                entity => entity.angular_component == component
            ]
        });
    }

    getByComponents(components: string[]){
        return this.selectAll({
           filterBy: [
               entity => entity.angular_component !== null && components.some((item: any) => item === entity.angular_component)
           ]
        });
    }

    getById(id: any){
        return this.selectAll({
            filterBy: [
              entity => entity.cent_aq_question_id == id
            ]
          });
    }

    feedMenuGroups(){
        return this.selectAll({
            filterBy: [
                entity => entity.group_type !== null && entity.group_type !== ''
            ]
        })
    }
}
